import React from "react";
import { Redirect } from "react-router-dom";
import styled from "styled-components";
import { FixedContainer, PageBody } from "../common/components/PageBody";
import { LoadingIndicator } from "../common/features/Utils";
import { YourApplications } from "../common/features/YourApplications";
import { OrgContext } from "../common/OrgContext";
import { UserContext } from "../common/UserContext";

const WelcomeSection = styled.div`
  text-align: center;
  padding: 40px 20px;
  background: linear-gradient(135deg, #f8f9ff 0%, #f0f2ff 100%);
  border-radius: 12px;
  margin-bottom: 30px;

  h1 {
    color: #333;
    font-size: 2.5em;
    margin-bottom: 15px;
    font-weight: 600;
  }

  p {
    color: #666;
    font-size: 1.2em;
    max-width: 800px;
    margin: 0 auto;
    line-height: 1.6;
  }

  @media (max-width: 768px) {
    padding: 25px 15px;
    margin-bottom: 20px;

    h1 {
      font-size: 1.8em;
      margin-bottom: 10px;
    }

    p {
      font-size: 1em;
      line-height: 1.4;
    }
  }
`;

const ApplicationsSection = styled.div`
  margin-top: 30px;
`;

export const HomePage = () => {
  const user = React.useContext(UserContext)?.user;
  const org = React.useContext(OrgContext);

  if (!org) {
    return (
      <PageBody>
        <FixedContainer>
          <div style={{ color: "#BBB", textAlign: "center", padding: "100px" }}>
            <LoadingIndicator size="4x" />
            <br />
            Loading...
          </div>
        </FixedContainer>
      </PageBody>
    );
  }

  if (!user) {
    return <Redirect to="/enroll" />;
  }

  return (
    <PageBody>
      <FixedContainer>
        <WelcomeSection>
          <h1>Welcome to Your Learning Journey</h1>
          <p>
            Track your applications, explore available programs, and continue your
            educational journey. Whether you're just starting or continuing your
            learning path, we're here to support you every step of the way.
          </p>
        </WelcomeSection>

        <ApplicationsSection>
          <YourApplications />
        </ApplicationsSection>
      </FixedContainer>
    </PageBody>
  );
};
